import * as Actions  from '../ViewCourse/CRS_action'

export interface CRS_State {
    Id_Course: string,
    SelectedIndex: number
}

const initialState: CRS_State = {
    Id_Course: "",
    SelectedIndex: 0
}

const CRS_reducer = (state = initialState, action: any ) =>{
    switch(action.type){
        case Actions.SET_COURSE_ID: return {...state, Id_Course: action.payload}
        case Actions.SET_COURSE_SELECTED_INDEX: return {...state, SelectedIndex: action.payload}
        default:
            return state
    }
}

export default CRS_reducer